import { Option } from "@components/global/CustomSelect/CustomSelect";
import { ISparePartType } from "./SpareParts.http";

export function typesToOptions(types: ISparePartType[]): Option<number>[] {
  const result: Option<number>[] = [];
  if (types) {
    for (let i = 0; i < types.length; i++) {
      result.push({
        label: types[i].Name,
        value: types[i].Id
      } as Option<number>);
    }
  }
  return result;
}